<template>
	<div class="disavow-table">
		<v-dialog v-model="groupAssign" width="50%">
			<div class="group-assign-modal-container">
				<h1>Assign To:</h1>
				<v-progress-circular
					class="bulk-assign-loader"
					indeterminate
					color="primary"
					v-if="userAssignLoading"
				></v-progress-circular>
				<v-select
					v-model="selectedBulkAssignUser"
					:items="users"
					name="user"
					item-text="name"
				>
				</v-select>

				<div
					v-if="selected.length > 20"
					class="group-assign-selected-links-container"
				>
					<h1>Groups Selected:</h1>

					<div
						class="group-assign"
						v-for="(link, index) in 20"
						:key="link.group"
					>
						{{ selected[index].group }}
					</div>
					{{ "+ " + (selected.length - 20) + " more" }}
				</div>

				<div v-else class="group-assign-selected-links-container">
					<h1>Groups Selected:</h1>

					<div class="group-assign" v-for="link in selected" :key="link.group">
						{{ link.group }}
					</div>
				</div>

				<v-btn
					@click="bulkAssignGroups"
					class="assign-groups-button"
					color="primary"
					>Assign</v-btn
				>
			</div>
		</v-dialog>

		<v-dialog
			v-model="dialog"
			overlay-color="rgba(0,0,0,0.1)"
			width="85%"
			flat="true"
		>
			<v-toolbar dark color="blue">
				<v-toolbar-title>Group Links</v-toolbar-title>
			</v-toolbar>
			<div class="link-modal-header">
				<BaseFilters
					:headers="headers"
					@filtersUpdated="filtersUpdated"
					@toggleModal="toggleModal"
					:modalData="modalData"
					@fetchLinks="fetchLinks"
				></BaseFilters>
				<BaseActiveLinkFilters @fetchLinks="fetchLinks"></BaseActiveLinkFilters>
			</div>

			<div class="modal-body">
				<v-data-table
					:items="links"
					:headers="innerHeaders"
					:loading="loading"
					show-select
					v-model="innerSelected"
				>
					<template v-slot:item.created_at="{ item }">
						<div>
							{{ item.created_at | formatDate }}
						</div>
					</template>

					<template v-slot:item.url="{ item }">
						<a v-bind:href="item.url" target="_blank">{{ item.url }}</a>
					</template>

					<template v-slot:item.updated_at="{ item }">
						{{ item.updated_at | formatDate }}
					</template>

					<template v-slot:item.disavow_status="{ item }">
						<v-btn-toggle
							v-model="item.disavow_status"
							:color="linkStatusColor(item.disavow_status)"
							group
							:mandatory="true"
						>
							<v-btn
								icon
								small
								v-for="(status, name) in linkStatus"
								:key="name"
								:value="name"
								@click="setLinkStatus(item, status)"
							>
								<v-icon small>{{ status.icon }}</v-icon>
							</v-btn>
						</v-btn-toggle>
					</template>

					<template v-slot:item.anchor_text="{ item }">
						<div class="no-wrap">{{ item.anchor_text }}</div>
					</template>

					<template v-slot:item.pre_text="{ item }">
						<div class="no-wrap">{{ item.pre_text }}</div>
					</template>
				</v-data-table>
			</div>
			<div class="d-flex align-center justify-space-between">
				<div>
					<v-menu
						:offset-y="true"
						v-if="innerSelected.length > 0"
						transition="scroll-y-transition"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="secondary" v-bind="attrs" v-on="on"
								><v-icon left>mdi-checkbox-multiple-marked</v-icon>Bulk Update
								({{ innerSelected.length }})</v-btn
							>
						</template>
						<v-list nav dense>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Bulk Link Actions</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item
								v-for="(status, name) in linkStatus"
								:key="name"
								@click="bulkLinkStatus(name)"
							>
								<v-list-item-icon class="mr-4">
									<v-icon v-text="status.icon" :color="status.color"></v-icon>
								</v-list-item-icon>
								<v-list-item-content>{{
									name | capitalize
								}}</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</div>
		</v-dialog>
		<header class="disavow-table__header">
			<div class="d-flex justify-space-between align-center  ">
				<AdminTabs v-if="currentUser.admin === true"></AdminTabs>
				<ICTabs v-else></ICTabs>
				<div class="ml-8 d-flex flex-nowrap">
					<v-tooltip bottom>
						<template v-slot:activator="{ on: tooltip }">
							<v-btn large icon @click="fetchGroups" v-on="{ ...tooltip }">
								<v-icon>mdi-refresh</v-icon>
							</v-btn>
						</template>
						<span>Refresh Table</span>
					</v-tooltip>
					<BaseGroupsFilters
						:headers="headers"
						@filtersUpdated="filtersUpdated"
					></BaseGroupsFilters>

					<BaseColumnVisibility
						@columnVisibility="columnVisibilityUpdated"
						:headers="headers"
						:innerHeaders="innerHeaders"
					/>
					<BaseRules :headers="headers" @rulesUpdated="rulesUpdated">
					</BaseRules>
				</div>
			</div>
			<div class="d-flex align-center flex-row-reverse">
				<BaseActiveFilters class="mw-50" @filtersUpdated="filtersUpdated" />
			</div>
		</header>

		<v-data-table
			id="data-table"
			class="disavow-table__content"
			:items="groups"
			:headers="visibleHeaders"
			:loading="loading"
			:options.sync="tableOptions"
			:item-class="itemRowBackground"
			:serverItemsLength="itemsPerPage"
			:rules="rules"
			item-key="id"
			show-select
			hide-default-footer
			v-model="selected"
		>
			<template v-slot:item.created_at="{ item }">
				<div>
					{{ item.created_at | formatDate }}
				</div>
			</template>

			<template v-slot:item.updated_at="{ item }">
				{{ item.updated_at | formatDate }}
			</template>

			<template v-slot:item.status="{ item }">
				<v-btn-toggle
					v-model="item.status"
					:color="domainStatusColor(item.status)"
					group
					:mandatory="false"
				>
					<v-btn
						icon
						small
						v-for="(status, name) in domainStatus"
						:key="name"
						:value="name"
						@click="setDisavowStatusHelp(item, name)"
					>
						<v-icon small>{{ status.icon }}</v-icon>
					</v-btn>
				</v-btn-toggle>
			</template>

			<template v-slot:item.domain="{ item }">
				<div class="no-wrap">
					{{ item.domain }}
				</div>
			</template>

			<template v-slot:item.group="{ item }">
				<span class="no-wrap">
					<a
						:href="itemLink(item.group)"
						target="_blank"
						class="url indigo--text"
						>{{ item.group }}</a
					>
				</span>
				<v-btn
					@click="toggleModal(item)"
					class="mx-2"
					fab
					x-small
					style="float: right"
					>...</v-btn
				>
			</template>

			<template v-slot:item.id="{ item }">
				{{ item.id }}
			</template>

			<template v-if="getAdminStatus()" v-slot:item.assignee_id="{ item }">
				<v-select
					:items="users"
					item-text="name"
					item-value="id"
					@change="changeAssignee(item)"
					v-model="assignees[groupIds.indexOf(item.id)]"
				>
				</v-select>
			</template>

			<template v-slot:item.updated_by="{ item }">
				{{ item.updated_by ? getUsersName(item.updated_by) : "null" }}
			</template>
		</v-data-table>

		<div class="d-flex align-center justify-space-between px-2 py-4">
			<div>
				<v-menu
					:offset-y="true"
					v-if="selected.length > 0 && this.getAdminStatus() === false"
					transition="scroll-y-transition"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="secondary" v-bind="attrs" v-on="on"
							><v-icon left>mdi-checkbox-multiple-marked</v-icon>Bulk Update ({{
								selected.length
							}})</v-btn
						>
					</template>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title>Bulk Domain Actions</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item
							v-for="action in bulkDomainActions"
							:key="action.title"
							@click="handleBulkActions(action)"
						>
							<v-list-item-icon class="mr-4">
								<v-icon v-text="action.icon" :color="action.color"></v-icon>
							</v-list-item-icon>
							<v-list-item-content>{{ action.title }}</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-menu
			
					:offset-y="true"
					v-else-if="selected.length > 0 && this.getAdminStatus() === true"
					transition="scroll-y-transition"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="secondary" v-bind="attrs" v-on="on"
							><v-icon left>mdi-checkbox-multiple-marked</v-icon>Bulk Update ({{
								selected.length
							}})</v-btn
						>
					</template>
					<v-list nav dense>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title>Bulk Domain Actions</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item
							v-for="action in bulkDomainActionsAdmin"
							:key="action.title"
							@click="handleBulkActions(action)"
						>
							<v-list-item-icon class="mr-4">
								<v-icon v-text="action.icon" :color="action.color"></v-icon>
							</v-list-item-icon>
							<v-list-item-content>{{ action.title }}</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>

			<div class="d-flex align-center">
				<small class="mr-3">Links per page:</small>

				<div class="itemsPerPageSelector">
					<v-select
						v-model="itemsPerPage"
						:items="[25, 50, 100, 250]"
						outlined
						dense
						class="flex-grow-0"
						hide-details="auto"
					></v-select>
				</div>
				<div class="pagination-container">
					<Pagination
						:calculatePages="calculatePages"
						:setPageNumber="setPageNumber"
						:pageNumber="pageNumber"
					/>
					<v-btn :disabled="hasPrevPage" text icon rounded @click="prevPage()"
						><v-icon>mdi-chevron-left</v-icon></v-btn
					>

					<v-btn
						:disabled="hasNextPage"
						class="ml-2"
						text
						icon
						rounded
						@click="nextPage()"
						><v-icon>mdi-chevron-right</v-icon></v-btn
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from "@/store/";

import moment from "moment";
import { mapState } from "vuex";

import AdminTabs from "@/components/AdminTabs.vue";
import ICTabs from "@/components/ICTabs.vue";
import Pagination from "@/components/Pagination.vue";
import BaseGroupsFilters from "@/components/BaseGroupsFilters.vue";
import BaseActiveLinkFilters from "@/components/BaseActiveLinkFilters.vue";
import APIService from "@/services/APIService.js";

export default {
	components: {
		AdminTabs,
		ICTabs,
		Pagination,
		BaseGroupsFilters,
		BaseActiveLinkFilters,
	},
	data() {
		return {
			dialog: false,
			userAssignLoading: false,
			users: [],
			currentUser: this.$store.getters["user/userInfo"],
			selectedBulkAssignUser: null,
			groupAssign: false,
			currentRoute: this.$route,
			modalData: {},

			pageNumber: 1,
			fetchGroupsConfig: {
				project_id: null,
				disavow_status: null,
				limit: 25,
				orderBy: "id",
				orderDir: "asc",
				before_id: null,
				after_id: null,
				assigned: true,
				page: 1,
			},
			//the assigned ^^ attribute is just do determine if we care if the groups/links are unassigned.
			fetchLinksConfig: {
				project_id: null,
				disavow_status: null,
				limit: 25,
				orderBy: "id",
				orderDir: "asc",
				before_id: null,
				after_id: null,
				group_id: null,
			},
			itemsPerPage: 25,
			options: {},
			project: null,
			projectName: null,
			loading: true,
			visibleColumns: null,
			tableOptions: {},
			visibleHeaders: [],
			dateFormat: "MM/DD/YYYY",
			linkStatus: {
				disavowed: {
					color: "red darken-2",
					status: "disavowed",
					icon: "mdi-thumb-down",
				},
				approved: {
					color: "green darken-2",
					status: "approved",
					icon: "mdi-thumb-up",
				},
				review: {
					color: "yellow darken-2",
					status: "review",
					icon: "mdi-help-circle",
				},
				unassigned: {
					color: "blue darken-2",
					icon: "mdi-alert-circle",
					status: "unassigned",
				},
			},

			bulkDomainActionsAdmin: {
				unAssgined: {
					title: "Unassign Groups",
					color: "blue darken-2",
					icon: "mdi-alert-circle",
					disavow_type: "domain",
					status: "unassigned",
					purpose: "status",
				},
				approveGroups: {
					title: "Approve Groups",
					color: "green darken-2",
					icon: "mdi-circle",
					disavow_type: "domain",
					status: "approved",
					purpose: "status",
				},

				disavowGroups: {
					title: "Disavow Groups",
					color: "red darken-2",
					icon: "mdi-close-octagon",
					disavow_type: "domain",
					status: "disavowed",
					purpose: "status",
				},
				reviewGroups: {
					title: "Review Groups",
					color: "yellow darken-2",
					icon: "mdi-help-circle",
					disavow_type: "domain",
					status: "review",
					purpose: "status",
				},

				assignGroups: {
					title: "Assign Groups to User",
					color: "purple",
					icon: "mdi-account-plus",
					disavow_type: "domain",
					status: "disavowed",
					purpose: "assign",
				},
			},
			bulkDomainActions: {
				unAssgined: {
					title: "Unassign Groups",
					color: "blue darken-2",
					icon: "mdi-alert-circle",
					disavow_type: "domain",
					status: "unassigned",
					purpose: "status",
				},
				approveGroups: {
					title: "Approve Groups",
					color: "green darken-2",
					icon: "mdi-circle",
					disavow_type: "domain",
					status: "approved",
					purpose: "status",
				},

				disavowGroups: {
					title: "Disavow Groups",
					color: "red darken-2",
					icon: "mdi-close-octagon",
					disavow_type: "domain",
					status: "disavowed",
					purpose: "status",
				},
				reviewGroups: {
					title: "Review Groups",
					color: "yellow darken-2",
					icon: "mdi-help-circle",
					disavow_type: "domain",
					status: "review",
					purpose: "status",
				},
			
			},
			domainStatus: {
				unassigned: {
					color: "teal darken-2",
					icon: "mdi-alert-circle",
				},
				disavowed: {
					color: "red darken-2",
					icon: "mdi-thumb-down",
				},
				approved: {
					color: "green darken-2",
					icon: "mdi-thumb-up",
				},
				review: {
					color: "yellow darken-2",
					icon: "mdi-help-circle",
				},
			},
			filters: {},
			initial: true,
			selected: [],
			innerSelected: [],
		};
	},
	watch: {
		$route: {
			handler: function() {
				store.dispatch("project/setCurrentUrl", this.$route);
				this.resetPages();
			},

			deep: true,
			immediate: true,
		},

		tableOptions() {
			if (!this.initial) {
				let options = this.tableOptions;

				this.fetchGroupsConfig.orderBy =
					options.sortBy.length > 0 ? options.sortBy[0] : "ID";

				this.fetchGroupsConfig.orderDir =
					options.sortDesc.length && options.sortDesc[0] ? "desc" : "asc";

				if (this.fetchGroupsConfig.orderBy === "id") {
					this.fetchGroupsConfig.orderBy = "ID";
				}

				let orderAndDirObject = {
					order: this.fetchGroupsConfig.orderBy,
					direction:
						options.sortDesc.length && options.sortDesc[0] ? "desc" : "asc",
				};
				store.dispatch("project/setCurrentSortAndDir", orderAndDirObject);
				this.resetTable();
				console.log(this.fetchGroupsConfig);
				this.fetchGroups();
			} else {
				this.initial = false;
			}
		},
		// Watches the itemsPerPage variable and refreshes the table when it changes
		itemsPerPage() {
			this.fetchGroupsConfig.limit = this.itemsPerPage;

			this.resetTable();
			this.fetchGroups();
		},
		visibleColumns() {
			this.visibleHeaders = [];
			this.headers.forEach((header) => {
				if (this.visibleColumns.includes(header.text)) {
					this.visibleHeaders.push(header);
				}
			});
		},
	},
	mounted() {
		APIService.getUsers(this.fetchGroupsConfig.project_id).then((res) => {
			let theUsers = res.data.results;
			console.log(this.$store);
			this.$store.dispatch("users/setUsers", res.data.results);

			this.users = theUsers;
		});
	},
	filters: {
		formatDate: function(date) {
			if (!date) return "";
			return moment(date).format("MM/DD/YYYY");
		},
		capitalize: function(value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	methods: {
		getUsersName(userID) {
			let usersName;

			let theUser = this.users.filter((user) => user.id == userID);

			if (typeof theUser[0] == "object") {
				if (Object.hasOwn(theUser[0], "name")) {
					usersName = theUser[0].name;
				} else {
					usersName = "No Name";
				}
			}

			return usersName;
		},
		getAdminStatus() {
			console.log('test')
			return this.$store.getters["user/userInfo"].admin;
		},
		resetPages() {
			console.log("reset pages");
			this.fetchGroupsConfig.page = 1;
			this.pageNumber = 1;
		},
		setPageNumber(page) {
			if (!this.loading) {
				this.fetchGroupsConfig.page = page;
				this.pageNumber = page;
				console.log(page);
				this.fetchGroups();
			}
		},
		calculatePages() {
			let pageCount = 0;
			let currentTab = this.$route.params.status;
			let theCounts = store.getters["project/counts"];
			pageCount = Math.ceil(theCounts[currentTab] / this.itemsPerPage);
			return pageCount;
		},
		fetchCounts() {
			let theCounts = store.getters["project/counts"];
			console.log(theCounts);
		},
		handleBulkActions(action) {
			if (action.purpose === "assign") {
				this.groupAssign = true;
			} else {
				this.bulkDomainStatus(action);
				console.log(action);
			}
		},

		bulkAssignGroups() {
			let oldGroups = JSON.parse(JSON.stringify([...this.selected]));
			let selectedGroups = JSON.parse(JSON.stringify([...this.selected]));
			let selectedUser;

			this.users.forEach((user) => {
				if (user.name === this.selectedBulkAssignUser) {
					console.log(user.id);
					selectedUser = user.id;
				}
			});

			//Deletes the color and num_links properties on the object

			selectedGroups.forEach((group) => {
				delete group.num_links;
				delete group.color;
				group.assignee_id = selectedUser;
			});

			oldGroups.forEach((group) => {
				delete group.num_links;
				delete group.color;
			});

			this.userAssignLoading = true;

			APIService.updateDomains(selectedGroups).then(() => {
				const notification = {
					type: "assigned",
					message: `${this.selected.length} group(s) assigned to ${this.selectedBulkAssignUser}`,
				};
				store.dispatch("notification/add", notification, { root: true });
				this.groupAssign = false;

				console.log(this.selected);
				console.log(selectedGroups);

				let sessionChangeObject = {
					type: "bulk-assign",
					oldGroups: oldGroups,
					newGroups: selectedGroups,
					newAssignee: this.selectedBulkAssignUser,
					project_id: this.fetchGroupsConfig.project_id,
				};

				console.log(sessionChangeObject);

				store.dispatch("sessionHistory/addChange", sessionChangeObject);

				this.selected = [];
				this.userAssignLoading = false;
				this.fetchGroups();
			});
		},

		toggleModal(item) {
			console.log(item);
			this.modalData = item;
			this.fetchLinksConfig.group_id = item.id;
			this.fetchLinksConfig.disavow_status = item.status;
			this.fetchLinksConfig.assigned = true;
			this.fetchLinksConfig.project_id = item.project_id;
			this.fetchLinksConfig.limit = item.num_links;
			this.dialog = true;
			this.fetchLinks();
			console.log(this.links);
		},
		nextPage() {
			if (!this.loading) {
				this.fetchGroupsConfig.page++;
				this.pageNumber++;
				this.fetchGroups();
			}
		},
		prevPage() {
			if (!this.loading) {
				if (this.fetchGroupsConfig.page - 1 <= 1) {
					this.fetchGroupsConfig.page = 1;
				} else {
					this.fetchGroupsConfig.page--;
				}
				this.pageNumber = this.fetchGroupsConfig.page;
				this.fetchGroups();
			}
		},
		fetchLinks() {
			console.log(this.fetchLinksConfig);

			store
				.dispatch("project/fetchLinks", {
					config: this.fetchLinksConfig,
				})
				.then((res) => {
					console.log(res);
					this.loading = false;
				});
		},
		fetchGroups() {
			console.log(this.fetchGroupsConfig);
			console.log(this.$route);
			let userID = this.$store.getters["user/userInfo"].user;
			console.log(userID);
			let fetchGroupsConfig = { ...this.fetchGroupsConfig };

			if (this.getAdminStatus() === false) {
				fetchGroupsConfig.assignee_id = userID;
			}
			//Get the users ID
			store
				.dispatch("project/fetchGroups", {
					config: fetchGroupsConfig,
				})
				.then(() => {
					this.loading = false;
					this.itemRowBackgroundHelp();
				});
		},
		resetTable() {
			this.loading = true;
			store.dispatch("project/clearLinks");
		},
		columnVisibilityUpdated(value) {
			this.visibleColumns = value;
		},
		filtersUpdated() {
			this.fetchGroups();
		},
		rulesUpdated() {
			//Delete the color property before posting again
			this.itemRowBackgroundHelp();
		},
		linkStatusColor(status) {
			return this.linkStatus[status].color;
		},
		domainStatusColor(status) {
			if (
				status !== "myNew" &&
				status !== "allNew" &&
				status !== "unassigned"
			) {
				return this.domainStatus[status].color;
			} else return "white";
		},
		bulkDomainStatus(domainStatus) {
			this.loading = true;
			let selectedLinks = this.selected.map(function(item) {
				return item;
			});

			let sessionChangeObject = {
				selectedLinks: selectedLinks,
				type: "bulk",
				oldStatus: selectedLinks[0].status,
				newStatus: domainStatus.status,
				project_id: this.fetchGroupsConfig.project_id,
			};

			console.log(selectedLinks[0].status);

			let theOldData = {
				groups: selectedLinks,
				disavow_type: domainStatus.disavow_type,
				status: domainStatus.status,
				project_id: this.fetchGroupsConfig.project_id,
			};

			console.log(theOldData);

			let newDataTest = [...theOldData.groups];
			newDataTest.forEach((item) => {
				item.status = domainStatus.status;
				delete item.num_links;
				delete item.color;
				item.updated_by = this.$route.params.user;
				return item;
			});

			APIService.updateDomains(newDataTest)
				.then((res) => {
					console.log(res);
					const notification = {
						type: domainStatus.status,
						message: `${this.selected.length} domains set to <i>${domainStatus.status}</i>`,
					};
					store.dispatch("notification/add", notification, { root: true });
					console.log(res);
					store.dispatch("sessionHistory/addChange", sessionChangeObject);
					this.selected = [];
					this.fetchGroups();
				})
				.catch((error) => {
					const notification = {
						type: "error",
						message: "Bulk Update Error",
					};
					store.dispatch("notification/add", notification, { root: true });
					console.log(error);
				});
		},
		bulkLinkStatus(status) {
			console.log(status);
			let oldStatus = this.innerSelected[0].disavow_status;
			let newStatus = status;

			let selectedLinks = this.innerSelected.map(function(item) {
				item.disavow_status = status;
				return { id: item.id, disavow_status: status };
			});

			console.log(this.innerSelected);

			let sessionChangeObject = {
				urls: this.innerSelected,
				links: selectedLinks,
				type: "bulk-link",
				oldStatus: oldStatus,
				newStatus: newStatus,
				project_id: this.fetchGroupsConfig.project_id,
			};

			console.log(sessionChangeObject);

			APIService.updateLinks(selectedLinks)
				.then(() => {
					const notification = {
						type: status,
						message: `${this.innerSelected.length} links set to <i>${status}</i>`,
					};
					store.dispatch("notification/add", notification, { root: true });
					store.dispatch("sessionHistory/addChange", sessionChangeObject);

					this.innerSelected = [];
				})
				.catch((error) => {
					const notification = {
						type: "error",
						message: "Bulk Update Error",
					};

					store.dispatch("notification/add", notification, { root: true });
					console.log(error);
				});
		},
		setLinkStatus(item, status) {
			console.log(status.status);
			console.log(item);
			let oldStatus = item.disavow_status;
			let newLinkItem = { ...item };
			console.log(newLinkItem);
			newLinkItem.disavow_status = status.status;
			let sessionChangeObject = {
				link: newLinkItem,
				type: "single-link",
				oldStatus: oldStatus,
				newStatus: status.status,
				project_id: this.fetchGroupsConfig.project_id,
			};

			APIService.updateLink(newLinkItem)
				.then((response) => {
					console.log(response);
					let response_data = JSON.parse(response.config.data);
					console.log(response_data);
					const notification = {
						type: response_data.disavow_status,
						message: `Link Status set to <i>${response_data.disavow_status}</i>:`,
						details: response_data.url,
					};

					store.dispatch("sessionHistory/addChange", sessionChangeObject);
					store.dispatch("notification/add", notification, { root: true });
				})
				.catch((error) => {
					const notification = {
						type: "error",
						message: "Error updating <i>Link Status</i> for:",
						details: item.url,
					};
					store.dispatch("notification/add", notification, { root: true });
					console.log(error);
				});
		},
		setDisavowStatusHelp(item, status) {
			console.log(item);

			if (item.status != status) {
				let sessionChangeObject = {
					item: item,
					status: status,
					type: "single",
				};

				store.dispatch("sessionHistory/addChange", sessionChangeObject);
				this.setDisavowStatus(item, item.id, item.type, status);

				//Still needs to call this.setDisavowStatus
			}
		},

		setDisavowStatus(item, link_id, type, status) {
			console.log(status);
			delete item.num_links;
			delete item.color;
			item.updated_by = this.$route.params.user;
			if (link_id && type && status != undefined) {
				this.loading = true;
				APIService.setDisavowStatus(item, link_id, type, status)

					.then((res) => {
						const notification = {
							type: status,
							message: `Group Status set to <i>${status}</i>`,
							details: item.group,
						};
						console.log(item.group);
						console.log(res);

						store.dispatch("notification/add", notification, { root: true });

						this.fetchGroups();
					})
					.catch((e) => {
						console.log(e);
						console.error(
							"There was an error with setDisavowStatus",
							link_id,
							type,
							status
						);
					});
			}
		},
		getProjectByID(id) {
			var project = this.projects.filter((project) => {
				return project.id === parseInt(id);
			});

			return project[0];
		},
		getProjectNameByID(id) {
			var project = this.getProjectByID(id);
			return project.name;
		},
		initProject(id, status) {
			this.project = this.getProjectByID(id);
			this.projectName = this.getProjectNameByID(id);

			this.$emit("currentProject", this.projectName);

			this.fetchGroupsConfig.page = 1;
			this.fetchGroupsConfig.project_id = id;
			if (status == "allNew") {
				this.fetchGroupsConfig.disavow_status = "unassigned";
				this.fetchGroupsConfig.assigned = "false";
			} else if (status == "myNew") {
				this.fetchGroupsConfig.disavow_status = "unassigned";
				this.fetchGroupsConfig.assigned = "true";
			} else if (status == "unassigned") {
				this.fetchGroupsConfig.assigned = "true";
				this.fetchGroupsConfig.disavow_status = "unassigned";
			} else {
				this.fetchGroupsConfig.disavow_status = status;
				this.fetchGroupsConfig.assigned = "true";
			}
		},
		itemRowBackgroundHelp() {
			let changedGroups = [...this.groups];
			changedGroups.forEach((item) => {
				let result = "default-link";

				this.rules.forEach((rule) => {
					for (const property in item) {
						if (rule[property] !== undefined) {
							//only do shared properties

							if (
								rule[property] !== null &&
								item[property] !== null &&
								item[property].includes(rule[property])
							) {
								//check if row breaks the rule

								if (result !== "bad-link") {
									result = rule.ruleType ? "good-link" : "bad-link";
								}
							}
						}
					}
				});

				//this.groups[index].color = result;

				item.color = result;
			});

			store.dispatch("project/setGroups", changedGroups);
			console.log(changedGroups);
			console.log("trying this out");
		},
		itemRowBackground(item) {
			if (item.color) {
				return item.color;
			}
			return "default-link";
		},
		itemLink(name) {
			return "http://" + name + "/";
		},
		changeAssignee(item) {
			//grap selection id and pass into item

			let prevUser;
			let newUser;
			let newUserID = this.assignees[this.groupIds.indexOf(item.id)];

			//	let userObject;
			let i;
			for (i = 0; i < this.users.length; i++) {
				if (this.users[i].id === item.assignee_id) {
					//userObject = this.users[i];
					prevUser = this.users[i];
				}

				if (this.users[i].id === newUserID) {
					newUser = this.users[i];
				}
			}
			console.log(newUser);
			if (!prevUser) {
				prevUser = null;
			}

			let sessionChangeObject = {
				groupItem: item,
				type: "assignee",
				oldStatus: prevUser,
				newStatus: newUser,
				project_id: this.fetchGroupsConfig.project_id,
			};

			console.log(item);

			APIService.updateGroupUser(
				item,
				this.assignees[this.groupIds.indexOf(item.id)]
			).then((res) => {
				console.log(res);
				store.dispatch("sessionHistory/addChange", sessionChangeObject);
				this.fetchGroups();
				const notification = {
					type: "assigned",
					message: `${item.group} assigned to ${newUser.name}`,
				};
				store.dispatch("notification/add", notification, { root: true });
			});
		},
		turnLinksIntoGroups() {
			APIService.createGroupsFromLinks();

			this.getUsersName(288);

			// console.log(this.$store.getters["user/userInfo"]);
		},
	},
	created() {
		this.initProject(
			this.$route.params.id,
			this.$route.params.status,
			this.$route.params.user
		);
		this.fetchGroups();
	},
	beforeRouteUpdate(to, from, next) {
		if (to !== from && !this.loading) {
			this.resetTable();
			this.initProject(to.params.id, to.params.status, to.params.user);
			this.fetchGroups();

			this.selected = [];
			next();
		} else {
			next(false);
		}
	},
	computed: {
		...mapState({
			projects: (state) => state.projects.projects,
			links: (state) => state.project.links,
			groups: (state) => state.project.groups,
			assignees: (state) => state.project.assignees,
			hasNextPage: (state) => state.project.next_page,
			hasPrevPage: (state) => state.project.prev_page,
			headers: (state) => state.project.headers,
			innerHeaders: (state) => state.project.innerHeaders,
			rules: (state) => state.rules.rules,
		}),
		groupIds() {
			return this.groups.map((x) => x.id);
		},
	},
};
</script>

<style lang="scss">
@import "../assets/temp.css";

.good-link {
	background-color: #d3f5d5 !important;
}
.bad-link {
	background-color: #f5d5db !important;
}

.test_background {
	background-color: orange !important;
	color: red !important;
}

.default-link {
	background-color: white;
}

.modal_btn {
	float: right;
}

#data-table {
	th {
		border-top: 1px solid #e0e0e0;
	}
	tr:hover {
		td {
			&:nth-child(1) {
				background: #eeeeee;
			}
		}
	}

	td {
		border-bottom: 1px solid #e0e0e0;

		&:nth-child(1) {
			position: sticky;
			left: 0;
			background: #fff;
			z-index: 1;
		}

		&:nth-child(2) {
			position: sticky;
			left: 57px;
			background: #fff;
			z-index: 1;
		}

		&:nth-child(3) {
			position: sticky;
			left: 114px;
			background: #fff;
			z-index: 1;
			box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
				0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
				0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
		}
	}
	td,
	th {
		border-right: 1px solid #e0e0e0;
		white-space: nowrap;
	}
}

.v-data-table-header {
	th {
		position: sticky;
		top: 0;
		z-index: 2;
		background: white;
		box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04),
			0 0.125rem 0.25rem rgba(0, 0, 0, 0.02),
			0 0.25rem 0.5rem rgba(0, 0, 0, 0.01);

		&:first-child {
			left: 0;
			z-index: 3;
			box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
				0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
				0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
		}

		&:nth-child(2) {
			left: 57px;
			z-index: 3;
			box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
				0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
				0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
		}
		&:nth-child(3) {
			left: 114px;
			z-index: 3;
			box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
				0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
				0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
		}
	}

	th {
		white-space: nowrap;
	}
}

.disavow-table {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
}
.disavow-table__header {
	flex: 0 0 auto;
	padding: 1rem 1.5rem;
	position: relative;
	box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04),
		0 0.125rem 0.25rem rgba(0, 0, 0, 0.02), 0 0.25rem 0.5rem rgba(0, 0, 0, 0.01);
	z-index: 2;
}

.disavow-table__content {
	flex: 1 1 auto;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;

	.v-data-table__wrapper {
		flex: 1 1 auto;
		overflow: auto;
	}
	.v-data-footer {
		flex: 0 0 auto;
	}
}
</style>

<style lang="scss" scoped>
.no-wrap {
	white-space: nowrap;

	a {
		max-width: 50rem;
		text-overflow: ellipsis;
		display: inline-block;
		overflow: hidden;
	}
}
h1 {
	font-size: 1.25rem;
}
.itemsPerPageSelector {
	max-width: 5.5rem;
	margin-right: 1rem;
}

.modal-body {
	position: relative;
	background-color: white;
	height: 70vh;
	padding: 10px;
}

.site-preview-container {
	position: relative;
	width: 100%;
	height: 600px;
}

.open-links-button {
	position: absolute;
	box-shadow: 0px 0px 1px 1px gray;
	padding: 5px;
	bottom: 10px;
}

.group-assign-modal-container {
	position: relative;
	height: 500px;
	padding: 20px;
	background-color: white;
}

.pagination-container {
	display: flex;
	width: 350px;
	justify-content: space-between;
}

.page-number-block {
	background-color: white;
	box-shadow: 0px 0px 2px 2px gray;
	padding: 8px;
	border-radius: 3px;
	transition: 0.3s;
}

.page-number-block:hover {
	cursor: pointer;
	background-color: gray;
	color: white;
}

.assign-groups-button {
	position: absolute;
	width: 95%;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
}

.test-rule {
	color: red !important;
	background-color: green !important;
}

.group-assign {
	display: inline-block;
	margin-right: 5px;
	background-color: #bdc3c7;
	padding: 3px 20px;
	border-radius: 20px;
	margin-top: 10px;
}

.bulk-assign-loader {
	position: absolute;
	right: 10px;
	top: 10px;
}

.link-modal-header {
	background-color: white;
}
</style>
